
import { MODULE_DEF } from 'src/app/module.json';
import menuParseDecorator from 'src/decorators/menu_parse';
/****
 * @MENU_DEF: object : for providing menu definition in case of single application
 * 
 **/
export const GlobalVariable = {
    HEADER: {
        name: 'KareXpert',
        logo: 'assets/images/default/brand-logo.png',
        login_logo: 'assets/images/default/brand-logo.png',
        logo_small_path: 'assets/images/default/brand-logo.png',
        logo_initial: 'KX',
        fav_icon: 'assets/images/default/kx_favicon.png',
        banner: 'assets/images/default/login-BG.png',
        login_tag: 'SaaS Digital Healthcare Platform'
    },
    APPLICATION_NAME: "KareXpert",
    APPLICATION_AWARE: true,
    MULTI_ROLE: true,
    DEFAULT_APPLICATION: 'account-management',
    DEFAULT_APP: 'healthcare',
    API_VERSION: 'v1',
    ORG_AWARE: true,
    RBACK_ENABLED: true,
    ACCOUNT_AWARE: {
        AUTO_COLUMNS: [
            {
                "heading": "field.label.facility",
                "card_tag": null,
                "sortable": false,//always should be false, we can't do server side sorting on auto added column
                "name": "facility_id",
                "type": "auto_column",
                "getterValue": "facilityList",
                "order":10,
                "getterKey": "name"
            }
        ],
        AUTO_FILTERS: [
            {
                "label": "field.label.facility",
                "class_name": "kx-control col-lg-3 col-md-3 col-sm-4 col-xl-3 mb-3 fix",
                "order": -1,
                "type": "String",
                "component": "searchselect",
                "getterKey": "id",
                "getterValue": "value",
                "defaultsetting": {
                    "closeDropDownOnSelection": true,
                    "singleSelection": true,
                    "allowSearchFilter": true,
                    "checkBoxRequired": false,
                    "apliCall": false,
                    "advancesearch":false
                },
                "datasource": {
                    "possible_value": []
                },
                "name": "facility_id"
            }
        ]
    },
    ORG_KEY: "facility_id",
    JSON_DEF: {},
    MODULE_DEF: MODULE_DEF,
    DECORATOR_DEF: {
        'menuParseDecorator': menuParseDecorator
    },
    TEMPLATE_DEF: [],
    GET_CONFIGURATION: 'system-management',
    APPLICATIONS_STORE: ['inventory-management', 'pharmacy', 'emr', 'linen-laundry', 'cssd', 'ot', 'appointment', 'optical', 'order', 'diagnostic', 'insurance','payment','misreports', 'facility-management','account-management'],
    PROFILE_LOGO: 'assets/images/user-profile-image.png',
    AUTO_COLUMNS: [
        {
            "heading": "Care Type",
            "card_tag": null,
            "sortable": false,//always should be false, we can't do server side sorting on auto added column
            "name": "care_type_name",
            "config_key": "care_type",
            "universal_config_enabled": true,
            "universal_config_key": "multi_care_type",
            "grid_color_text": true,
                "class_conditions": [
                    {
                        "expression": "item['care_type']=='general'",
                        "class": "colorfur-text-day"
                    },
                    {
                        "expression": "item['care_type']=='prime'",
                        "class": "colorfur-text-prime"
                    }
                ]

        }
    ],
    AUTO_FILTERS: [
        {
            "universal_config_enabled": true,
            "filter_key": "care_type",
            "getterFun": (obj) => {
                var config = "care_type";
                var key = "id";
                var uni = obj[config] == undefined ? false : obj[config];
                if (uni) {
                    return uni.length != 0 ? uni[0][key] : false
                } else {
                    return "";
                }
            },
            "universal_config_key": "multi_care_type"
        }
    ],
    CONFIG_FUNCTIONS: [
        {
            name: "getCurrentCareType",
            fun: ['return this.getUniversalConfig("care_type").length != 0 ? this.getUniversalConfig("care_type")[0].id : false']
        },
        {
            name: "getCurrentCareTypeName",
            fun: ['return this.getUniversalConfig("care_type").length != 0 ? this.getUniversalConfig("care_type")[0].name : false']
        }
    ],
    ARCHIVE:{
        THIRTY:30,
        SIXTY:60,
        NINETY:90,
        ONEEIGHTY:180,
        ONESEVENTYNINE:179,
        THREESIXTYFIVE:365
    }
};